import { formatClock, formatDuration } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/**
 * Milliseconds as "19:03" (`clock`, chapter lengths and audio readouts) or in
 * words ("2 Std., 41 Min." / "2 hrs, 41 min", totals and estimates);
 * `approx` prefixes "≈ ".
 */
export function Duration({
  ms,
  style = "clock",
  approx = false,
}: {
  ms: number | null | undefined;
  style?: "clock" | "words";
  approx?: boolean;
}) {
  const locale = useInterfaceLocale();
  const text = style === "clock" ? formatClock(ms) : formatDuration(ms, locale);
  return (
    <span data-component="Duration" className="tabular-nums">
      {approx && text ? "≈ " : ""}
      {text}
    </span>
  );
}
